import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import languageList from '../profile/languageList.json';
import i18n from '../i18next/i18next';
import localeToLanguageName from '../../helper/localeToLanguageName';
import { setCookie } from '../../helper/cookieClient';

import '../../assets/css/footer.css';

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = { showing: false };
    document.addEventListener('click', this.globalClickListener);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.globalClickListener);
  }

  globalClickListener = nativeEvent => {
    // ignore click event happened inside the dropdown menu
    if (this._dropdown_body && this._dropdown_body.contains(nativeEvent.target))
      return;
    // else hide dropdown menu
    this.setState({ showing: false });
  };

  openCookiePreferences = () => {
    // Reopens the TrustArc preference manager via its hidden banner anchor
    const teconsentDiv = document.getElementById('teconsent');
    const link = teconsentDiv && teconsentDiv.getElementsByTagName('a')[0];
    if (link) {
      link.click();
    }
  };

  renderNewLanguageSection = () => {
    const { language, changeLanguage } = this.props;
    let langSelectedName = localeToLanguageName(language) || 'English';
    let langStyle = {};
    return (
      <div class="lang_area" ref={ref => (this._dropdown_body = ref)}>
        <div
          class="lang_list"
          id="lang_menu"
          style={{ display: this.state.showing ? 'block' : 'none' }}
        >
          {languageList.map((item, index) => {
            if (languageList.length - 1 === index) {
              langStyle = { borderBottom: 'none' };
            }
            return (
              <li
                class="list_item"
                style={langStyle}
                onClick={e => {
                  setCookie('lang', item.code);
                  changeLanguage(item.code);
                  this.setState({ showing: !this.state.showing });
                }}
              >
                {item.name}
              </li>
            );
          })}
        </div>
        <div
          class="btn_lang"
          onClick={() => this.setState({ showing: !this.state.showing })}
        >
          {langSelectedName}
        </div>
      </div>
    );
  };

  render() {
    const { language } = this.props;
    const year = new Date().getFullYear();
    return (
      <div className="container footer_content">
        <div className="com_info">
          {i18n.t('copyRight', { lng: language, year })}
        </div>
        <div className="docu_link">
          <span>
            <a href="/terms-of-use">{i18n.t('terms', { lng: language })}</a>
          </span>
          <span>
            <a href="/privacy-policy">{i18n.t('privacy', { lng: language })}</a>
          </span>
          <span>
            <a href="/privacy-pledge">
              {i18n.t('privacyPledge.PrivacyPledge', { lng: language })}
            </a>
          </span>
          <span onClick={this.openCookiePreferences}>
            <a href="#" onClick={e => e.preventDefault()}>
              {i18n.t('cookiePreferences', {
                lng: language,
                defaultValue: 'Cookie Preferences'
              })}
            </a>
          </span>
        </div>
        {this.renderNewLanguageSection()}
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/common/Footer.js